/**
 * Creates bound event handlers for native events
 */
export function createBoundEventHandlers(context, handlers) {
    const bubbleNativeEvent = (event) => {
        if (event instanceof KeyboardEvent) {
            event.stopImmediatePropagation();
            const newEvent = new KeyboardEvent(event.type, {
                bubbles: false,
                composed: false,
                key: event.key,
                code: event.code,
                ctrlKey: event.ctrlKey,
                altKey: event.altKey,
                shiftKey: event.shiftKey,
                metaKey: event.metaKey,
                repeat: event.repeat,
                isComposing: event.isComposing,
                view: event.view,
            });
            context.dispatchEvent(newEvent);
        }
        else if (event.type === 'change') {
            // For change, we can dispatch the event normally (no modification needed)
            context.dispatchEvent(new Event(event.type, { bubbles: true, composed: true }));
        }
    };
    return {
        keyUp: handlers.keyUp || bubbleNativeEvent,
        keyDown: handlers.keyDown || bubbleNativeEvent,
        keyPress: handlers.keyPress || bubbleNativeEvent,
        focus: handlers.focus || bubbleNativeEvent,
        blur: handlers.blur || bubbleNativeEvent,
        change: handlers.change || bubbleNativeEvent,
        input: handlers.input || bubbleNativeEvent,
        setupEventListeners: (element) => {
            if (element) {
                element.addEventListener('keyup', handlers.keyUp || bubbleNativeEvent);
                element.addEventListener('keydown', handlers.keyDown || bubbleNativeEvent);
                element.addEventListener('keypress', handlers.keyPress || bubbleNativeEvent);
                element.addEventListener('focus', handlers.focus || bubbleNativeEvent);
                element.addEventListener('blur', handlers.blur || bubbleNativeEvent);
                element.addEventListener('change', handlers.change || bubbleNativeEvent);
                element.addEventListener('input', handlers.input || bubbleNativeEvent);
            }
        },
        removeEventListeners: (element) => {
            if (element) {
                element.removeEventListener('keyup', handlers.keyUp || bubbleNativeEvent);
                element.removeEventListener('keydown', handlers.keyDown || bubbleNativeEvent);
                element.removeEventListener('keypress', handlers.keyPress || bubbleNativeEvent);
                element.removeEventListener('focus', handlers.focus || bubbleNativeEvent);
                element.removeEventListener('blur', handlers.blur || bubbleNativeEvent);
                element.removeEventListener('change', handlers.change || bubbleNativeEvent);
                element.removeEventListener('input', handlers.input || bubbleNativeEvent);
            }
        },
    };
}
